import type { Dec } from './dec'

/**
 * Nomi fissi di dimensioni e misure delle righe. Il template del tracciato
 * puo' riferire solo questi: `caricaRegolePeriodo` lo verifica al caricamento.
 */
export const CAMPI_MODELLO = [
  'ambito',
  'mese',
  'matricola',
  'lettA',
  'lettP',
  'diffLett',
  'costLett',
  'tipologia',
  'tipoScambio',
  'idControparte',
  'codCat',
  'progr',
  'numeroUtenze',
  'rett',
  'kwh',
  'aliquota',
  'accisa',
  'totE',
  'totM',
  'totaleAccisaDovuta',
  'acconto',
  'creditoInizio',
  'debitoInizio',
  'creditoFine',
  'debitoFine',
  'impDovuta',
  'credUtilizzato',
  'impVersata',
  'credMaturatoMese',
  'debMaturatoMese',
  'totImpDovuta',
  'totCred',
  'totImpVersata',
  'tipologiaVendita',
  'provenienza',
  'id',
] as const
export type CampoModello = (typeof CAMPI_MODELLO)[number]

export const QUADRI_MODELLO = ['A', 'B', 'C', 'E', 'G', 'H', 'Perdite', 'J', 'L', 'M', 'Q', 'S', 'N', 'T'] as const
export type QuadroModello = (typeof QUADRI_MODELLO)[number]

export type ValoreRiga = string | number | Dec
export type RigaMutabile = Partial<Record<CampoModello, ValoreRiga | undefined>>
export type Riga = Readonly<RigaMutabile>
export type ModelloDichiarazione = Readonly<Partial<Record<QuadroModello, readonly Riga[]>>>
